import { Box, Button, Flex, Grid, Input, Text } from "@chakra-ui/react";
import { Select } from "antd";
import React from "react";
import ThreeModeFilter from "../../Components/Admin/ThreeModeFilter";
import { filterCountries } from "../../Utils/countries";

// Claude: extracted from Seller.tsx 23-03-2026
// Claude: always visible; companyName moved inside panel; show/hide removed 20-05-2026
interface Props {
  pendingSearch: Record<string, string>;
  setPendingSearch: React.Dispatch<React.SetStateAction<any>>;
  pendingSearchModes: Record<string, string>;
  setPendingSearchModes: React.Dispatch<React.SetStateAction<any>>;
  pendingEventId: string;
  setPendingEventId: (v: string) => void;
  emptySearch: Record<string, string>;
  eventData: any[];
  industryNodes: any[];
  departmentOptions: { label: string; value: string }[]; // Claude: target department filter 18-04-2026
  onReset: () => void;
  onApply: () => void;
}

const SellerAdvancedSearch = ({
  pendingSearch, setPendingSearch, pendingSearchModes, setPendingSearchModes,
  pendingEventId, setPendingEventId, emptySearch, eventData, industryNodes, departmentOptions, onReset, onApply,
}: Props) => {
  return (
    <Box mt={2} p={3} border="1px solid" borderColor="gray.200" borderRadius="md" bg="white">
      <Grid templateColumns="repeat(4, 1fr)" gap={2} mb={2}>
        <Box>
          <Text fontSize="xs" color="gray.500" mb="2px">Company Name</Text>
          <Input size="xs" h="26px" fontSize="xs" value={pendingSearch.companyName}
            onChange={e => setPendingSearch((p: any) => ({ ...p, companyName: e.target.value }))} />
        </Box>
        <Box>
          <Text fontSize="xs" color="gray.500" mb="2px">Country</Text>
          {/* Claude: showSearch + Any + Is empty for Country 23-03-2026 */}
          <Select showSearch style={{ height: "26px", width: "100%", fontSize: "12px" }}
            value={pendingSearch.companyHqCountry || ''}
            onChange={v => setPendingSearch((p: any) => ({ ...p, companyHqCountry: v }))}
            filterOption={(input, option) =>
              !input || option?.value === '' || option?.value === '__empty__' ||
              String(option?.label ?? '').toLowerCase().includes(input.toLowerCase())
            }
            options={[
              { label: "Any", value: "" },
              { label: "Is empty", value: "__empty__" },
              ...filterCountries("").map((c) => ({ label: c.value, value: c.value })),
            ]}
          />
        </Box>
        <Box>
          <Text fontSize="xs" color="gray.500" mb="2px">Industry</Text>
          {/* Claude: showSearch + Any + Is empty for Industry 21-03-2026 */}
          <Select showSearch style={{ height: "26px", width: "100%", fontSize: "12px" }}
            value={pendingSearch.industryId || ''}
            onChange={v => setPendingSearch((p: any) => ({ ...p, industryId: v }))}
            filterOption={(input, option) =>
              !input || option?.value === '' || option?.value === '__empty__' ||
              String(option?.label ?? '').toLowerCase().includes(input.toLowerCase())
            }
            options={[
              { label: "Any", value: "" },
              { label: "Is empty", value: "__empty__" },
              ...industryNodes.filter((n: any) => !n.parentId).map((n: any) => ({ label: n.name, value: n._id })),
            ]}
          />
        </Box>
        <Box>
          <Text fontSize="xs" color="gray.500" mb="2px">City</Text>
          <Input size="xs" h="26px" fontSize="xs" value={pendingSearch.companyHqCity}
            onChange={e => setPendingSearch((p: any) => ({ ...p, companyHqCity: e.target.value }))} />
        </Box>
        <Box>
          <Text fontSize="xs" color="gray.500" mb="2px">State</Text>
          <Input size="xs" h="26px" fontSize="xs" value={pendingSearch.companyHqState}
            onChange={e => setPendingSearch((p: any) => ({ ...p, companyHqState: e.target.value }))} />
        </Box>
        <Box>
          <Text fontSize="xs" color="gray.500" mb="2px">Event</Text>
          <Select
            showSearch optionFilterProp="label"
            style={{ height: "26px", width: "100%", fontSize: "12px" }}
            placeholder="All events"
            onChange={(value) => setPendingEventId(value)}
            options={[{ label: "All", value: "" }, { label: "No Event", value: "none" }, ...eventData]}
            value={pendingEventId}
          />
        </Box>
        <ThreeModeFilter label="Timezone" fieldKey="companyTimezone"
          pendingSearch={pendingSearch} setPendingSearch={setPendingSearch}
          modes={pendingSearchModes} setModes={setPendingSearchModes} />
        <ThreeModeFilter label="Website" fieldKey="companyUrl"
          pendingSearch={pendingSearch} setPendingSearch={setPendingSearch}
          modes={pendingSearchModes} setModes={setPendingSearchModes} />
        <ThreeModeFilter label="Company Info" fieldKey="companyInfo"
          pendingSearch={pendingSearch} setPendingSearch={setPendingSearch}
          modes={pendingSearchModes} setModes={setPendingSearchModes} />
        <ThreeModeFilter label="Product Tags" fieldKey="productTypeTags"
          pendingSearch={pendingSearch} setPendingSearch={setPendingSearch}
          modes={pendingSearchModes} setModes={setPendingSearchModes} />
        <Box>
          <Text fontSize="xs" color="gray.500" mb="2px">Person Name</Text>
          <Input size="xs" h="26px" fontSize="xs" value={pendingSearch.personName}
            onChange={e => setPendingSearch((p: any) => ({ ...p, personName: e.target.value }))} />
        </Box>
        <Box>
          <Text fontSize="xs" color="gray.500" mb="2px">Email</Text>
          <Input size="xs" h="26px" fontSize="xs" value={pendingSearch.personEmail}
            onChange={e => setPendingSearch((p: any) => ({ ...p, personEmail: e.target.value }))} />
        </Box>
        <Box>
          <Text fontSize="xs" color="gray.500" mb="2px">Phone</Text>
          <Input size="xs" h="26px" fontSize="xs" value={pendingSearch.personPhoneNumber}
            onChange={e => setPendingSearch((p: any) => ({ ...p, personPhoneNumber: e.target.value }))} />
        </Box>
        <ThreeModeFilter label="Designation" fieldKey="personDesignation"
          pendingSearch={pendingSearch} setPendingSearch={setPendingSearch}
          modes={pendingSearchModes} setModes={setPendingSearchModes} />
        {/* Claude: Status filter removed 21-03-2026 — status field merged into verificationStatus */}
        <Box>
          <Text fontSize="xs" color="gray.500" mb="2px">Verification</Text>
          <Select style={{ height: "26px", width: "100%", fontSize: "12px" }}
            value={pendingSearch.verificationStatus || ''}
            onChange={v => setPendingSearch((p: any) => ({ ...p, verificationStatus: v }))}
            options={[
              { label: "Any", value: "" },
              { label: "Verified", value: "verified" },
              { label: "Unverified", value: "unverified" },
              { label: "Provisional", value: "provisional" },
              { label: "Blocked", value: "blocked" },
              { label: "Resubmitted", value: "resubmitted" },
              { label: "Pending New User", value: "pendingNewUser" },
              { label: "Inactive", value: "inactive" },
            ]}
          />
        </Box>
        <Box>
          <Text fontSize="xs" color="gray.500" mb="2px">LinkedIn Verified</Text>
          <Select style={{ height: "26px", width: "100%", fontSize: "12px" }}
            value={pendingSearch.linkedinVerified || ''}
            onChange={v => setPendingSearch((p: any) => ({ ...p, linkedinVerified: v }))}
            options={[{ label: "Any", value: "" }, { label: "Yes", value: "true" }, { label: "No", value: "false" }]}
          />
        </Box>
        <Box>
          <Text fontSize="xs" color="gray.500" mb="2px">Subscriptions</Text>
          <Select style={{ height: "26px", width: "100%", fontSize: "12px" }}
            value={pendingSearch.isPlanActive || ''}
            onChange={v => setPendingSearch((p: any) => ({ ...p, isPlanActive: v }))}
            options={[{ label: "Any", value: "" }, { label: "Yes", value: "true" }, { label: "No", value: "false" }]}
          />
        </Box>
        {/* Claude: company type filter 14-04-2026 */}
        <Box>
          <Text fontSize="xs" color="gray.500" mb="2px">Company Type</Text>
          <Select style={{ height: "26px", width: "100%", fontSize: "12px" }}
            value={pendingSearch.sellerCompanyType || ''}
            onChange={v => setPendingSearch((p: any) => ({ ...p, sellerCompanyType: v }))}
            options={[
              { label: "Any", value: "" },
              { label: "Manufacturing", value: "Manufacturing" },
              { label: "Trade", value: "Trade" },
              { label: "Services/Solutions", value: "Services/Solutions" },
              { label: "Others", value: "Others" },
            ]}
          />
        </Box>
        {/* Claude: target filters 18-04-2026 */}
        <Box>
          <Text fontSize="xs" color="gray.500" mb="2px">Target Country</Text>
          <Select showSearch style={{ height: "26px", width: "100%", fontSize: "12px" }}
            value={pendingSearch.targetCountry || ''}
            onChange={v => setPendingSearch((p: any) => ({ ...p, targetCountry: v }))}
            filterOption={(input, option) =>
              !input || option?.value === '' || String(option?.label ?? '').toLowerCase().includes(input.toLowerCase())
            }
            options={[
              { label: "Any", value: "" },
              ...filterCountries("").map((c) => ({ label: c.value, value: c.value })),
            ]}
          />
        </Box>
        <Box>
          <Text fontSize="xs" color="gray.500" mb="2px">Target Industry</Text>
          <Select showSearch style={{ height: "26px", width: "100%", fontSize: "12px" }}
            value={pendingSearch.targetIndustryId || ''}
            onChange={v => setPendingSearch((p: any) => ({ ...p, targetIndustryId: v }))}
            filterOption={(input, option) =>
              !input || option?.value === '' || String(option?.label ?? '').toLowerCase().includes(input.toLowerCase())
            }
            options={[
              { label: "Any", value: "" },
              ...industryNodes.filter((n: any) => !n.parentId).map((n: any) => ({ label: n.name, value: n._id })),
            ]}
          />
        </Box>
        <Box>
          <Text fontSize="xs" color="gray.500" mb="2px">Target Department</Text>
          <Select showSearch style={{ height: "26px", width: "100%", fontSize: "12px" }}
            value={pendingSearch.targetDepartmentId || ''}
            onChange={v => setPendingSearch((p: any) => ({ ...p, targetDepartmentId: v }))}
            filterOption={(input, option) =>
              !input || option?.value === '' || String(option?.label ?? '').toLowerCase().includes(input.toLowerCase())
            }
            options={[
              { label: "Any", value: "" },
              ...departmentOptions,
            ]}
          />
        </Box>
      </Grid>
      <Flex gap={2} justifyContent="flex-end">
        <Button size="xs" fontSize="xs" px={4} onClick={onReset}>Reset</Button>
        <Button size="xs" fontSize="xs" px={4} background="#0E122F" color="white"
          _hover={{ background: "#2E7D32" }} onClick={onApply}
        >
          Apply
        </Button>
      </Flex>
    </Box>
  );
};

export default SellerAdvancedSearch;
